import { createFileRoute } from '@tanstack/react-router';
import { AudiencesSettingsRouteView } from '@/pages/workspaces/integrations/audiences/routing';
import { LastWorkspaceResolver } from './-components';

function AudiencesSettingsRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <AudiencesSettingsRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/settings')({
  component: AudiencesSettingsRoute,
});
